import { ReactElement } from 'react';

import { BadgeComponent, GradientTextEnabler } from './styles';
import { BadgeProps } from './types';

const Badge = ({
	className,
	children,
	borderColor = 'badgeBorder',
	backgroundColor = 'badgeBg',
	textColor = 'badgeText',
}: BadgeProps): ReactElement => {
	return (
		<BadgeComponent
			className={className}
			$borderColor={borderColor}
			$backgroundColor={backgroundColor}
			$textColor={textColor}
		>
			<GradientTextEnabler $textColor={textColor}>{children}</GradientTextEnabler>
		</BadgeComponent>
	);
};

export default Badge;
